const uspsButton = document.querySelectorAll('.usp-btn');
let filterData = []; // caching fetched data

if ( uspsButton.length ) {
  uspsButton.forEach( function( item ) {
    item.addEventListener('click', function() {
      const { url, title } = item.dataset;
      if (!url) return;

      const filterDataUrl = element => element.url === url;
      filterData.some(filterDataUrl) ?
        renderFromCache(filterDataUrl, title) :
        url.includes('/policies') ? 
          renderFromFetch(url, title, 'main') : 
          renderFromFetch(url, title, '#main .PageContent');
    });
  });
}

function renderFromFetch(url, title, querySelector) {
  renderModalHTML(' ', ' '); // reset modal
  fetch(url)
  .then(response => response.text())
  .then(data => {
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(data, 'text/html');
      const pageContent = htmlDoc.querySelector(querySelector);
      if (!pageContent) {
        // if not default page - use main of the page
        const contentWithOutStart = data.substring(data.indexOf('<div id="shopify-section-page'));
        const contentMain = contentWithOutStart.substring(0, contentWithOutStart.indexOf('</main>'));
        renderModalHTML(contentMain, title);
        return;
      };
      const html = pageContent.innerHTML;
      filterData = [...filterData, { url, html }]; // caching fetched data
      if (html) renderModalHTML(html, title);
  })
}

function renderFromCache(filterDataUrl, title) {
  renderModalHTML(' ', ' '); // reset modal
  const { html } = filterData?.find(filterDataUrl);
  if (!html) return;
  renderModalHTML(html, title);
}

function renderModalHTML(html, title) {
  const modalTitle = document.querySelector('#modal_page_info .Modal__Title');
  if (modalTitle && title) modalTitle.innerText = title;
  const modalContent = document.querySelector('#modal_page_info .Modal__Content');
  if (modalContent && html) modalContent.innerHTML = html;
}